import { makeRequest } from './data_utils';

// ================================
// Template Operations
// ================================

const getTemplates = () => {
    const endpoint = `api/templates`;
    return makeRequest(endpoint, 'GET');
};

const createTemplate = (type, role, name, description, created_by = '') => {
    const endpoint = `api/templates`;
    const body = {
        type: type,
        role: role,
        name: name,
        description: description,
        created_by: created_by
    };
    return makeRequest(endpoint, 'POST', body);
};

const getTemplate = (templateId) => {
    const endpoint = `api/templates/${templateId}`;
    return makeRequest(endpoint, 'GET');
};

const getCompleteTemplate = (templateId) => {
    const endpoint = `api/templates/${templateId}/complete`;
    return makeRequest(endpoint, 'GET');
};

const updateTemplate = (templateId, type, role, name, description, active) => {
    const endpoint = `api/templates/${templateId}`;
    const body = {
        type: type,
        role: role,
        name: name,
        description: description,
        active: active
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deleteTemplate = (templateId) => {
    const endpoint = `api/templates/${templateId}`;
    return makeRequest(endpoint, 'DELETE');
};

const getTemplatesByType = (type) => {
    const endpoint = `api/templates/type/${type}`;
    return makeRequest(endpoint, 'GET');
};

// ================================
// Template Objectives Operations
// ================================

const getTemplateObjectives = (templateId) => {
    const endpoint = `api/templates/${templateId}/objectives`;
    return makeRequest(endpoint, 'GET');
};

const createObjective = (templateId, name, description, ordinal, prompt_id, llm_model) => {
    const endpoint = `api/templates/${templateId}/objectives`;
    const body = {
        name: name,
        description: description,
        ordinal: ordinal,
        prompt_id: prompt_id,
        llm_model: llm_model
    };
    return makeRequest(endpoint, 'POST', body);
};

const updateObjective = (objectiveId, name, description, ordinal, prompt_id, active, llm_model) => {
    const endpoint = `api/templates/objectives/${objectiveId}`;
    const body = {
        name: name,
        description: description,
        ordinal: ordinal,
        prompt_id: prompt_id,
        active: active,
        llm_model: llm_model
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deleteObjective = (objectiveId) => {
    const endpoint = `api/templates/objectives/${objectiveId}`;
    return makeRequest(endpoint, 'DELETE');
};

// ================================
// Template Objectives Tasks Operations
// ================================

const getObjectiveTasks = (objectiveId) => {
    const endpoint = `api/templates/objectives/${objectiveId}/tasks`;
    return makeRequest(endpoint, 'GET');
};

const createTask = (objectiveId, name, description, description_short, ordinal) => {
    const endpoint = `api/templates/objectives/${objectiveId}/tasks`;
    const body = {
        name: name,
        description: description,
        description_short: description_short,
        ordinal: ordinal
    };
    return makeRequest(endpoint, 'POST', body);
};

const updateTask = (taskId, name, description, description_short, ordinal, active) => {
    const endpoint = `api/templates/tasks/${taskId}`;
    const body = {
        name: name,
        description: description,
        description_short: description_short,
        ordinal: ordinal,
        active: active
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deleteTask = (taskId) => {
    const endpoint = `api/templates/tasks/${taskId}`;
    return makeRequest(endpoint, 'DELETE');
};

// ================================
// Template Focuses Operations
// ================================

const getTemplateFocuses = (templateId) => {
    const endpoint = `api/templates/${templateId}/focuses`;
    return makeRequest(endpoint, 'GET');
};

const createFocus = (templateId, name, description, ordinal) => {
    const endpoint = `api/templates/${templateId}/focuses`;
    const body = {
        name: name,
        description: description,
        ordinal: ordinal
    };
    return makeRequest(endpoint, 'POST', body);
};

const updateFocus = (focusId, name, description, ordinal, active) => {
    const endpoint = `api/templates/focuses/${focusId}`;
    const body = {
        name: name,
        description: description,
        ordinal: ordinal,
        active: active
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deleteFocus = (focusId) => {
    const endpoint = `api/templates/focuses/${focusId}`;
    return makeRequest(endpoint, 'DELETE');
};

// ================================
// Template Conclusions Operations
// ================================

const getTemplateConclusions = (templateId) => {
    const endpoint = `api/templates/${templateId}/conclusions`;
    return makeRequest(endpoint, 'GET');
};

const createConclusion = (templateId, name, description, ordinal) => {
    const endpoint = `api/templates/${templateId}/conclusions`;
    const body = {
        name: name,
        description: description,
        ordinal: ordinal
    };
    return makeRequest(endpoint, 'POST', body);
};

const updateConclusion = (conclusionId, name, description, ordinal, active) => {
    const endpoint = `api/templates/conclusions/${conclusionId}`;
    const body = {
        name: name,
        description: description,
        ordinal: ordinal,
        active: active
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deleteConclusion = (conclusionId) => {
    const endpoint = `api/templates/conclusions/${conclusionId}`;
    return makeRequest(endpoint, 'DELETE');
};

// ================================
// Clone Template Operations
// ================================

const cloneTemplate = (templateId, name, description) => {
    const endpoint = `api/templates/${templateId}/clone`;
    const body = {
        name: name,
        description: description
    };
    return makeRequest(endpoint, 'POST', body);
};


export const templateData = {
    // Template Operations
    getTemplates,
    getCompleteTemplate,
    createTemplate,
    getTemplate,
    updateTemplate,
    deleteTemplate,
    getTemplatesByType,
    
    // Template Objectives Operations
    getTemplateObjectives,
    createObjective,
    updateObjective,
    deleteObjective,
    
    // Template Objectives Tasks Operations
    getObjectiveTasks,
    createTask,
    updateTask,
    deleteTask,
    
    // Template Focuses Operations
    getTemplateFocuses,
    createFocus,
    updateFocus,
    deleteFocus,
    
    // Template Conclusions Operations
    getTemplateConclusions,
    createConclusion,
    updateConclusion,
    deleteConclusion,

    // Clone Template
    cloneTemplate
}; 
